import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { CheckMarkFillLegacy } from '@lyearn/icons';
import { Stack, Typography } from '@lyearn/ui';

function SurveyStatus() {
  const { t } = useTranslation();

  return (
    <Stack alignItems="center" className="mt-12 flex-shrink-0" gapX={8}>
      <CheckMarkFillLegacy className="h-20 w-20" fillColorToken="icon-success" />
      <Typography color="text-text-paragraph" variant="body-short-02">
        {t('Common:ContentCards.Submitted')}
      </Typography>
    </Stack>
  );
}

export default SurveyStatus;
